jQuery(function () {

    // FORM MODAL TEMPORAL

    var $modal = $("#form-modal");
    var $slider = $(".slick-form-modal");

    $slider.slick({
        arrows: false,
        draggable: false,
        fade: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        adaptiveHeight: true,
    });

    $slider.find(".multiselector-categoria").on("click", function () {
      $slider.slick("slickNext");
    });

    $slider.find(".step-categoria-nombre").on("click", function () {
      $slider.slick("slickPrev");
    });

    $slider.on("afterChange", function (event, slick, currentSlide) {
        
        if (currentSlide === 2) {
            if (!$modal.hasClass("limit-width")) {
                $modal.addClass("limit-width");
            } else {
                if ($modal.hasClass("limit-width")) {
                    $modal.removeClass("limit-width");
                }
            }
        }

        setTimeout(function () {
            $slider.slick("setPosition");
        }, 420);

        if (currentSlide === 1) {
            $(".form-modal-content-cabecera .pasos span").text("2");
        }
        if (currentSlide === 2) {
            $(".form-modal-content-cabecera .title-cabecera").text("¿Dónde contactamos contigo?");
            $(".form-modal-content-cabecera .pasos span").text("3");
        }
    });

    $slider.find(".btn-back").on("click", function () {
        $slider.slick("slickGoTo", 0, false);
        $(".form-modal-content-cabecera .pasos span").text("1");
        $(".form-modal-content-cabecera .title-cabecera").text("Infórmate gratis y sin compromiso");

        $modal.removeClass("limit-width");

        setTimeout(function () {
            $slider.slick("setPosition");
        }, 420);
    });

    // Saber si esta el nav sticked
    var $header       = $('.menu-wrapper');
    var $mainNav      = $('.main-nav-wrapper');
    var $window       = $(window);
    var hasNotification = $('#header-notification').length > 0;
    var initialTop    = hasNotification ? 120 : 64;

    if (window.matchMedia("(max-width: 1199px)").matches) {
        calculateScroll();
    }

    function calculateScroll() {
        var finalTop = 64;

        function checkScroll() {
            var scrollTop  = $window.scrollTop();
            var dynamicTop = Math.max(finalTop, initialTop - scrollTop);
            $header.css({ top: dynamicTop + 'px', height: 'calc(100dvh - ' + dynamicTop + 'px)' });
            $mainNav.css('top', dynamicTop + 'px');
            $header.toggleClass('scrolled', scrollTop > finalTop);
        }

        checkScroll();
        $window.on('scroll', checkScroll);
    }

    // Menu movil

    var menuAbierto = false;
    $(".menu-movil").on("click", function () {
        $(this).toggleClass("close");
        if (!menuAbierto) {
            $("body").addClass("blocked");
            $(".menu-wrapper").toggleClass("close");
            setTimeout(function () {
                $(".main-nav-wrapper").toggleClass("close");
                if (!$("header").hasClass("scrolled")) $("header").addClass("semi-scrolled");
            }, 350);
        } else {
            $(".main-nav-wrapper").toggleClass("close");
            setTimeout(function () {
                $(".menu-wrapper").toggleClass("close");
                if ($("header").hasClass("semi-scrolled")) $("header").removeClass("semi-scrolled");
                $("body").removeClass("blocked");
            }, 250);
        }
        menuAbierto = !menuAbierto;
    });

    // Submenu movil

    $(".open-sub").each(function () {
        $(this).on("click", function (e) {
            if (window.matchMedia("(max-width: 1199px)").matches) {
                e.preventDefault();
                $('#' + $(this).data("submenu")).toggleClass("close open");
            }
        });
    });

    // Subdrop back — resetea panel izquierdo al cerrar en móvil
    $(".subdrop-back").on("click", function () {
        const $subdrop = $(this).closest('.subdrop');
        $subdrop.removeClass("open").addClass("close");
        $subdrop.find('.subdrop-izq').removeClass('is-visible');
    });

    const DURATION = 280;

    $('.subdrop').each(function () {
        const $subdrop = $(this);
        const $img     = $subdrop.find('.subdrop-izq-foto img');
        const $title   = $subdrop.find('.subdrop-izq-foto-title');
        const $items   = $subdrop.find('.subdrop-izq-info li');
        const $izq     = $subdrop.find('.subdrop-izq');

        // Timer propio por cada subdrop para poder cancelarlo
        let animTimer    = null;
        let itemTimers   = [];

        const defaultState = {
            img:      $img.attr('src'),
            alt:      $img.attr('alt'),
            title:    $title.text(),
            features: $items.map(function () {
                return $(this).html();
            }).get()
        };

        function cancelTimers() {
            if (animTimer) {
                clearTimeout(animTimer);
                animTimer = null;
            }
            itemTimers.forEach(function (t) { clearTimeout(t); });
            itemTimers = [];
        }

        function animateLeft(data) {
            // Cancelamos cualquier animación en curso antes de iniciar
            cancelTimers();

            // Limpiamos clases residuales de animaciones anteriores
            $img.add($title).add($items).removeClass('is-changing');

            // Forzamos reflow para que la transición se reinicie limpia
            $izq[0].offsetHeight;

            $izq.css('max-height', $izq.outerHeight() || 'none');
            $img.add($title).add($items).addClass('is-changing');

            animTimer = setTimeout(function () {
                const isDefault = (data === defaultState);
                const validDataFeatures = (data.features || []).filter(f => f && String(f).trim() !== '');
                const hasFeaturesInRow = (validDataFeatures.length > 0);

                // Imagen: si no hay imagen, usamos la de por defecto
                const imgToUse = (data.img && !data.img.endsWith('/') && data.img !== '') ? data.img : defaultState.img;
                const altToUse = (data.title && data.title.trim() !== '') ? data.title : defaultState.title;
                
                $img.attr({ src: imgToUse, alt: altToUse }).show();
                $img.closest('.subdrop-izq-foto').show();

                // Título: si está vacío usamos el de por defecto
                const titleToUse = (data.title && data.title.trim() !== '') ? data.title : defaultState.title;
                $title.text(titleToUse).show();

                // Características: Usamos el HTML capturado si es por defecto, o actualizamos con el SVG si es data nueva
                const featuresData = isDefault ? defaultState.features : data.features;
                let actuallyHasFeatures = false;

                $items.each(function (i) {
                    if (isDefault) {
                        if (featuresData[i]) {
                            $(this).html(featuresData[i]).show();
                            actuallyHasFeatures = true;
                        } else {
                            $(this).hide();
                        }
                    } else {
                        const feature = (featuresData && featuresData[i]) ? String(featuresData[i]).trim() : '';
                        if (feature !== '') {
                            const $svg = $(this).find('svg').detach();
                            $(this).empty().append($svg).append(' ' + feature).show();
                            actuallyHasFeatures = true;
                        } else {
                            $(this).hide();
                        }
                    }
                });

                // Si es el estado por defecto, forzamos mostrar info (porque tiene features capturadas)
                // Si son datos nuevos, solo mostramos si realmente hay features
                if (isDefault || actuallyHasFeatures) {
                    $subdrop.find('.subdrop-izq-info').show();
                } else {
                    $subdrop.find('.subdrop-izq-info').hide();
                }

                $izq.css('max-height', 'none');
                const targetHeight = $izq.outerHeight();
                $izq.css('max-height', $izq.outerHeight() + 'px');
                $izq[0].offsetHeight;
                $izq.css('max-height', targetHeight + 'px');

                if (!$izq.hasClass('is-visible')) {
                    $izq.addClass('is-visible');
                }

                $img.add($title).removeClass('is-changing');
                $items.each(function (i) {
                    const $li = $(this);
                    const t = setTimeout(function () {
                        $li.removeClass('is-changing');
                    }, i * 60);
                    itemTimers.push(t);
                });

                animTimer = null;
            }, DURATION);
        }

        $subdrop.find('.subdrop-links-list ul').each(function () {
            const headerText = $(this).find('li.header').text().trim();
            const sectionKey = Object.keys(sectionData).find(key => headerText.includes(key));

            $(this)
                .on('mouseenter', function () {
                    if (sectionKey) {
                        animateLeft(sectionData[sectionKey]);
                    } else {
                        animateLeft(defaultState);
                    }
                })
                .on('mouseleave', function () { animateLeft(defaultState); });
        });

        // Reset al salir del li padre en desktop
        $subdrop.closest('li').on('mouseleave', function () {
            animateLeft(defaultState);
        });
    });

    // Animacion Drop del Footer

    $('.footer-link-title-wrapper').each(function () {
        $(this).click(function () {
            if (window.matchMedia("(max-width: 1199px)").matches) {
                const drop     = $(this).next();
                const dropList = drop.find('ul');
                if (drop.hasClass('drop-open')) {
                    dropList.removeClass('nav-visible');
                    setTimeout(function () { drop.removeClass('drop-open'); }, 50);
                } else {
                    drop.addClass('drop-open');
                    setTimeout(function () { dropList.addClass('nav-visible'); }, 350);
                }
                $(this).toggleClass("open close");
            }
        });
    });

    
    // Tabs del modulo Media Highlight

    if ($('.module-media-highlight').length > 0) {
        $('.module-media-highlight-content-columns').removeClass('active-panel').hide();
        $('.module-media-highlight-content-columns').first().addClass('active-panel').css('display', 'grid');
        $('.item-tab-menu').first().addClass('tab-active');
        $('.item-tab-menu').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('tab-active')) return;
            $('.item-tab-menu').removeClass('tab-active');
            $(this).addClass('tab-active');
            $('.module-media-highlight-content-columns').hide().removeClass('active-panel');
            $($(this).attr('href')).css('display', 'grid').addClass('active-panel');
        });
    }

    // VIDEO MODULE VIDEO

    if ($('.module-video').length) {
      $('.module-video').each(function() {
        let playBtn = $(this).find('.play-btn');
        let img = $(this).find('.module-video-container-img');
        playBtn.on('click', function() {
          img.fadeOut(500);
          $(this).closest('.video-footer').fadeOut(500);
        });
      });
    }

    // MODAL VIDEO MEDIA
    if ($(".module-media").length > 0) {
        $(".module-media").find(".play-btn").parent().click(function () {
            
        var dataID = $(this).data("id");

        $(".overlay").fadeIn(500);
        $("body").addClass("blocked");
        setTimeout(function () {
            $("#video-content").attr("src", "https://www.youtube.com/embed/" + dataID + "?enablejsapi=1");
            $("#video-modal-wrapper").addClass("video-horizontal video-modal-activo");
        }, 500);
        });
    }

    // CARD PHOTO LINK TOOLTIP

   if ($('.card-photo-link').length > 0) {
        if (window.matchMedia("(max-width: 1199px)").matches) {
            $('.card-photo-link').each(function() {
                const card = $(this);
                const toggleBtn = card.find('.drop-icon');
                const list = card.find('.card-photo-link-list');
                const lineVertical = card.find('.line-vertical');

                $(toggleBtn).on('click', function() {
                    $(list).slideToggle();
                    $(this).toggleClass("open close");
                })
            })
        }
    }

    // MODULE DROPDOWNS

    if ($('.module-dropdown').length > 0) {
        $('.dropdown').each(function () {
            $(this).on('click', function () {
                $(this).find('.dropdown-drop').slideToggle();
                $(this).find('.drop-icon').toggleClass('drop-active');
            });
        });
    }

    // TEMPORAL SLICK FORM MULTISTEP

    $(".slick-form-multistep").slick({
      arrows: false,
      draggable: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
    });

    $('.multiselector-categoria').on('click', function(e) {
      e.preventDefault();

      cargaCursosMultistep($(this));
    })

    $('.multistep-cursos').on('click',function() {
      $(".slick-form-multistep").slick("slickPrev");
      $('.form-multistep-content-cabecera .pasos span').text('1');
    });

    // Volvemos al paso 1 si pulsamos el boton del form
    $('.btn-back').on('click',function() {
      $(".slick-form-multistep").slick('slickGoTo', 1);
      $('.form-multistep-content-cabecera .pasos span').text('2');
    });

    // Funcion para crear sliders

    function creaSlick(selector, config) {
        const $slider = $(`.${selector}`);
        if ($slider.length > 0) {
            $slider.each(function () {
                const $bar      = $(this).next('.slider-bar');
                const $range    = $bar.find('.slick-progress');
                const $progress = $bar.find('.slick-progress-bar');

                $(this).slick({ ...config, prevArrow: $bar.find('.slick-prev'), nextArrow: $bar.find('.slick-next') });

                const totalSlides = $(this).slick('getSlick').slideCount;
                $range.attr('max', totalSlides);
                if ($(this).slick('getSlick').options.slidesToShow >= totalSlides) $range.addClass('hidden');

                $(this).on('afterChange', function (e, slick, current) {
                    $progress.css('left', (current / totalSlides) * 100 + '%');
                });
            });
        }
    }

    creaSlick('slick-testimonials',       { arrows: true, autoplay: false, mobileFirst: true, slidesToShow: 1, variableWidth: true, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2 } }] });
    creaSlick('slick-product-conversion', { arrows: true, autoplay: false, mobileFirst: true, slidesToShow: 1, variableWidth:true, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2, variableWidth: false } }, { breakpoint: 1199, settings: { slidesToShow: 3, variableWidth: false } }] });
    creaSlick('slick-docentes',           { arrows: true, autoplay: false, mobileFirst: true, slidesToShow: 1, variableWidth: true, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2 } }] });
    creaSlick('slick-gallery',            { arrows: true, autoplay: false, mobileFirst: true, slidesToShow: 1, variableWidth: true, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2 } }, { breakpoint: 1199, settings: { slidesToShow: 4 } }] });
    creaSlick('slick-steps',              { arrows: true, autoplay: false, mobileFirst: true, slidesToShow: 1, variableWidth: true, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2 } }, { breakpoint: 1199, settings: { slidesToShow: 4 } }] });
    creaSlick('slick-gallery-modal',            { arrows: true, autoplay: false, infinite: true, mobileFirst: true, slidesToShow: 1, variableWidth:false, responsive: [{ breakpoint: 767, settings: { centerMode:true, centerPadding: '80px' } },{ breakpoint: 1199, settings: { centerMode:true, centerPadding: '120px'},},]})

  $(document).on('click', '.llamanos-btn', function () {
    jQuery.ajax({
      type: 'POST',
      url: rutajs + 'lib/ajax.php',
      data: 'fn=getModalTeLlamamos&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&rw=' +
        cdn_rutaweb,
      success: function (data) {
        if (data != '' && jQuery('#btn-llamamos').length == 0) {
          $('body').append(data);
          
          $(".overlay").fadeIn(500);
          $("body").addClass("blocked");
          $("#btn-llamamos").addClass("visible");

          setTimeout(function(){
            $('body').append("<script src='"+cdn_rutacdn+"llamamos/js/llamamos.js?v="+cdn_v+"'></script>");
          }, 1000);
        }
      },
    });
  });
});

function goTo(id, errorForm = '') {
  $("html, body").animate({ scrollTop: $("#" + id).offset().top }, "slow");

  if (!empty(errorForm)) {
    errorField = 'general';
    errorMessage = errorForm;
    enviarEventoFormulario(4, id);
  }
}

function empty(mixed_var) {
  //  discuss at: http://phpjs.org/functions/empty/
  // original by: Philippe Baumann
  //    input by: Onno Marsman
  //    input by: LH
  //    input by: Stoyan Kyosev (http://www.svest.org/)
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Onno Marsman
  // improved by: Francesco
  // improved by: Marc Jansen
  // improved by: Rafal Kukawski
  //   example 1: empty(null);
  //   returns 1: true
  //   example 2: empty(undefined);
  //   returns 2: true
  //   example 3: empty([]);
  //   returns 3: true
  //   example 4: empty({});
  //   returns 4: true
  //   example 5: empty({'aFunc' : function () { alert('humpty'); } });
  //   returns 5: false

  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, "", "0"];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === "object") {
    for (key in mixed_var) {
      // TODO: should we check for own properties only?
      //if (mixed_var.hasOwnProperty(key)) {
      return false;
      //}
    }
    return true;
  }

  return false;
}

//Añadir el solicitar info que cuelo irá con el CDN
$(document).on('click', '.solicita-informacion', function (e) {
  var esLlamada = $(this).is('#customEnlaceLlamadaFueraHorario');
  var eventoWeb = $(this).data('evento');

  cargaModal(e, null, null, eventoWeb, esLlamada);
});

// Metemos las tablas creadas mediante CMS dentro del Div
// correspondiente para poder usar el overflow

$('.textos-legales-section table').each(function() {
  var $div = $('<div>', { class: 'textos-legales-table' });
  
  $(this).wrap($div);
});

function cargaModal(e = null, categoria = null, curso = null, eventoWeb = undefined, esLlamada = false) {
  if (e && typeof e.stopPropagation === 'function') {
    e.preventDefault();
    e.stopPropagation();
  }
    
  if(!empty(categoria))
    catCuponPost = categoria;
  else
    catCuponPost = catCupon;

  if(!empty(curso))
    curCuponPost = curso;
  else
    curCuponPost = curCupon;

  if(eventoWeb == undefined)
    eventoWeb = 'Solicita_info';

  if(!empty(curCuponPost)) {
    mostrarOcultarSpinner(true, '.overlay');

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&fullWidth=' +
        JSON.parse(fullWidth),
      success: function (data) {
        if (data != '' && jQuery('#form-modal').length == 0) {
          $('body').append(data);
                
          $(".overlay").fadeIn(500);
          $("body").addClass("blocked");
    
          $(".slick-form-modal").slick({
            adaptiveHeight: true,
            arrows: false,
            draggable: false,
            fade:true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined){
            dataLayer = (typeof dataLayer !== 'undefined') ? dataLayer : [];
    
            dataLayer.push({
                event: "open_generic",
                customer_id: v_client_id,
                template: v_template,
                menu_level_1: v_menu_level_1,
                menu_level_2: v_menu_level_2,
                menu_level_3: v_menu_level_3,
                menu_level_4: v_menu_level_4,
                menu_level_5: v_menu_level_5,
                form_id: datalayerFormID,
                page_path: v_page_path,
                page_url: v_page_url
            });
    
            valorTipoCupon = 'Modal';
            enviarEventoViewForm('form-modal');
          }

          $("#datosCupon").html("");

          jQuery.ajax({
            type: "POST",
            async: true,
            url: rutajs + "lib/ajax.php",
            data: 'fn=getCupon&idCursoComercial=' + curCuponPost +
              '&isModal=' +
              '-modal' +
              '&iw=' +
              cdn_idweb +
              '&rcdn=' +
              cdn_rutacdn +
              '&pCupon=' +
              encodeURIComponent(pCupon) +
              '&rw=' +
              cdn_rutaweb,
            success: function (data) {

              if (data != '') {               
                $('#datosCupon').append(data);

                $(".slick-form-modal").slick("slickGoTo", 2);
                $(".modal-main-wrapper .pasos span").text("3");
                $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");
                $(".modal-overlay").css("max-width", "600px");

                if(hideBtnBackModal) {
                  $(".modal-main-wrapper .pasos").hide();
                  $(".modal-main-wrapper .btn-back").hide();
                }

                if(fullWidth) {
                  $(".modal-overlay").css("max-width", "max-content");
                }

                enviarEvento();
              }

              if(typeof loadRecaptchaLibrary === 'function')
                loadRecaptchaLibrary();
            },
          }).done(function(){
            $("#form-modal").addClass("visible");
            mostrarOcultarSpinner(false, '.overlay');

            setTimeout(function () {
              $('.slick-form-modal').slick('setPosition');
            }, 500);
          });
        }
      },
    })
  } else {
    mostrarOcultarSpinner(true, '#form-modal');

    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&fullWidth=' +
        JSON.parse(fullWidth),
      success: function (data) {
        if (data != '' && jQuery('#form-modal').length == 0) {
          $('body').append(data);
          
          $(".overlay").fadeIn(500);
          $("body").addClass("blocked");
          $("#form-modal").addClass("visible");
  
          $(".slick-form-modal").slick({
            adaptiveHeight: true,
            arrows: false,
            draggable: false,
            fade:true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
          });
  
          if(fullWidth) {
            $(".modal-overlay").css("max-width", "max-content");
          }
  
          $("#step-modal-categoria a").each(function () {
            $(this).on("click", function (e) {
              e.preventDefault();
  
              cargaCursos($(this));
            });
          });
          $(".back-1").on("click", function () {
            $(".step-tipo-formacion-nombre").hide();
            $(".slick-form-modal").slick("slickGoTo", 0);
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1015px");
          });
          $(".back-2").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1015px");
          });
          $(".back-3").on("click", function () {
            $(".tipo-formacion-general").hide();
            $(".slick-form-modal").slick("slickGoTo", 2);
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1015px");
          });
          $(".btn-back").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
            $(".modal-main-wrapper .pasos span").text("2");
            $(".modal-main-wrapper .title-cabecera").text("Infórmate gratis y sin compromiso");
  
            if(!fullWidth)
              $(".modal-overlay").css("max-width", "1000px");
          });
          $(".btn-form").on("click", function (e) {
            e.preventDefault();
            $(".slick-form-modal").slick("slickGoTo", 5);
            $(".modal-main-wrapper .pasos span").text("2");
            $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");
          });
  
          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined){
            dataLayer = (typeof dataLayer !== 'undefined') ? dataLayer : [];
  
            dataLayer.push({
                event: "open_generic",
                customer_id: v_client_id,
                template: v_template,
                menu_level_1: v_menu_level_1,
                menu_level_2: v_menu_level_2,
                menu_level_3: v_menu_level_3,
                menu_level_4: v_menu_level_4,
                menu_level_5: v_menu_level_5,
                form_id: datalayerFormID,
                page_path: v_page_path,
                page_url: v_page_url
            });
  
            valorTipoCupon = 'Modal';
            enviarEventoViewForm('form-modal');
          }
        }
      },
    }).done(function(){
      if (aCatCupon != '' && aCatCupon != undefined) {
        $('.multiselector-modal-categoria').closest('li').hide();
        
        $.each(aCatCupon, function(index, value) {
          $('#categoria-modal-' + value).closest('li').show();
        });
      }
  
      if (catCuponPost != '' && catCuponPost != undefined)
        $('#categoria-modal-' + catCuponPost).click();

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 500);
    });
  }
}

function cargaCursos(element) {
  var idCategoria = element.data('categoria');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#form-modal');

    $("#stepCursoModal").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursos&idCategoria=" + idCategoria,
      success: function (data) {

        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          html = '';

          $.each(data.aCursos, function (index, value) {            
            if (aCurCupon != '' && aCurCupon != undefined) {
              if($.inArray(value.idCursoComercial, aCurCupon) !== -1)
                html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip background-default size-m multiselector-modal-curso" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')">' + value.sNombre + '</a></li>';
            } else
              html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip background-default size-m multiselector-modal-curso" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')">' + value.sNombre + '</a></li>';
          });

          $("#stepCursoModal").html(html);

          $(".step-modal-categoria-nombre").html(sNombre + '<svg class="i"><use xlink:href="#edit-line"></use></svg>');
          
          $(".slick-form-modal").slick("slickGoTo", 1);
          $(".modal-main-wrapper .pasos span").text("2");

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "1000px");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
      setTimeout(function () {
        if (curCuponPost != "" && curCuponPost != undefined)
          $('#curso-' + curCuponPost).click();

        $('.slick-form-modal').slick('setPosition');
      }, 1000);

      mostrarOcultarSpinner(false, '#form-modal');
    });
  }
}

function cargaCursosMultistep(element) {
  var idCategoria = element.data('categoria');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#form-multistep');

    $("#stepCursoMultistep").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursos&idCategoria=" + idCategoria,
      success: function (data) {

        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          html = '';

          $.each(data.aCursos, function (index, value) {            
            if (aCurCupon != '' && aCurCupon != undefined) {
              if($.inArray(value.idCursoComercial, aCurCupon) !== -1)
                html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip background-default size-s " data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCuponMultistep($(this))">' + value.sNombre + '<svg><use xlink:href="#arrow-right"></use></svg></a></li>';
            } else
              html += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip background-default size-s " data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCuponMultistep($(this))">' + value.sNombre + '<svg><use xlink:href="#arrow-right"></use></svg></a></li>';
          });

          $("#stepCursoMultistep").html(html);

          $(".multistep-cursos").html(sNombre + '<svg class="i"><use xlink:href="#edit-line"></use></svg>');
          
          $(".slick-form-multistep").slick("slickNext");
          $('.form-multistep-content-cabecera .pasos span').text('2');

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "1000px");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function() {
      $('.slick-form-modal').slick('setPosition');
      mostrarOcultarSpinner(false, '#form-multistep');
    });
  }
}

function cargaCupon(element, isModal = '') {

  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#form-modal');

    $("#datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb,
      success: function (data) {

        if (data != '') {
          $('#datosCupon').append(data);

          $(".slick-form-modal").slick("slickGoTo", 2);
          $(".modal-main-wrapper .pasos span").text("3");
          $(".modal-main-wrapper .title-cabecera").text("¿Dónde contactamos contigo?");

          if(hideBtnBackModal) {
            $(".modal-main-wrapper .pasos").hide();
            $(".modal-main-wrapper .btn-back").hide();
          }

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "600px");

          enviarEvento();
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#form-modal');

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 500);
    });
  }
}

function cargaCuponMultistep(element, isModal = '') {
  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#form-multistep');

    $("#datosCuponMultistep").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb,
      success: function (data) {
        if (data != '') {
          $('#datosCuponMultistep').append(data);

          $(".step-curso-nombre").html(sNombre + '<svg class="i"><use xlink:href="#edit-line"></use></svg>');
          
          $(".slick-form-multistep").slick("slickNext");
          $('.form-multistep-content-cabecera .pasos span').text('3');

          if(!fullWidth)
            $(".modal-overlay").css("max-width", "600px");

          enviarEvento();
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#form-multistep');

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 500);
    });
  }
}

function getComboMD(tipo, required, padre, idForm = "frmCupon ") {
  jQuery.ajax({
    type: "POST",
    async: false,
    url: rutajs + "lib/ajax.php",
    data:
      "fn=getComboMD&tipo=" +
      tipo +
      "&required=" +
      required +
      "&padre=" +
      padre +
      "&idioma_cupon=" +
      idioma_cupon,
    success: function (data) {
      jQuery("#" + idForm + "#" + tipo + "id").html(data);

      if (tipo == "pais") {
        jQuery("#" + idForm + "#" + tipo + "id" + ' select option[value="' + idpais + '"]:first').prop("selected", true);

        configurarCamposCupon(idpais, idForm);
        configurarTelefono(idpais, prefijotelefonico, patterntelefonico, idForm);
      }
    },
  });
}

function chkPais(idpais, idForm = "frmCupon ") {
  $("#" + idForm + "#observaciones").hide(); //campo para guardar el código LADA (solo para méxico)
  $("#" + idForm + "#requeridos_observaciones").val(""); //Para que NO sea obligatorio el campo LADA por servidor (solo para méxico)

  configurarCamposCupon(idpais, idForm);

  if(!$("#" + idForm + "#prefTelf").hasClass("no-change")) {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCodigosPaises&idpais=" + idpais,
      success: function (data) {
        data = JSON.parse(data);

        configurarTelefono(idpais, data.sCodigoTelefonico, data.sTelefPattern, idForm);
      },
    }).done(function() {
      $('.slick-form-modal').slick('setPosition');
    });
  }
}

function chkPrefijo(sCodigoTelefonico, sCodPais, sTelefPattern, idForm = "frmCupon ", idCampoTelefono = "form_cupon_cupon_telefono") {
  if(!$("#" + idForm + "#prefTelf").hasClass("no-change"))
    $("#" + idForm + "#prefTelf").addClass("no-change")

  $("#" + idForm + '#observaciones').hide(); //campo para guardar el código LADA (solo para méxico)
  $("#" + idForm + '#requeridos_observaciones').val(''); //Para que NO sea obligatorio el campo LADA por servidor (solo para méxico)
  
  configurarTelefono(sCodPais, sCodigoTelefonico, sTelefPattern, idForm, idCampoTelefono);

  $("#" + idForm + '.telefono').unbind('mouseover mouseout').off();
}

function configurarCamposCupon(idpais, idForm = "frmCupon ") {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoCodigoPostal = "form_cupon_cupon_codigopostal";
  /***/ idCampoProvincia = "provinciaid";
  /***/
  /* ********************************************* */

  if (idpais == 90 || idpais == 'ES') {

    getComboMD("provincia", "true", idpais, idForm);
    
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", true);
    $("#" + idForm + "#" + idCampoCodigoPostal).show();
    $("#" + idForm + "." + idCampoCodigoPostal).show();
    $("#" + idForm + "#" + idCampoProvincia).attr("required", true);
    $("#" + idForm + "#" + idCampoProvincia).show();
    $("#" + idForm + "." + idCampoProvincia).show();

    $("#" + idForm + "#requeridos_codigo_postal").val("codigopostal"); //Para que sea obligatorio el campo código postal                $('#provinciaid').attr('required',true);
    $("#" + idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia

  } else if (idpais == 249 || idpais == 61) {

    getComboMD("provincia", "true", idpais, idForm);

    $("#" + idForm + "#" + idCampoProvincia).attr("required", true);
    $("#" + idForm + "#" + idCampoProvincia).show();
    $("#" + idForm + "." + idCampoProvincia).show();
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", false);
    $("#" + idForm + "#" + idCampoCodigoPostal).val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#" + idCampoCodigoPostal).hide();
    $("#" + idForm + "." + idCampoCodigoPostal).hide();

    $("#" + idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia
  } else {

    $("#" + idForm + "#" + idCampoProvincia).attr("required", false);
    $("#" + idForm + "#" + idCampoProvincia).hide();
    $("#" + idForm + "." + idCampoProvincia).hide();
    $("#" + idForm + "#" + idCampoProvincia + ' option[value=""]').prop("selected", true);
    $("#" + idForm + "#" + idCampoCodigoPostal).attr("required", false);
    $("#" + idForm + "#" + idCampoCodigoPostal).val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#" + idCampoCodigoPostal).hide();
    $("#" + idForm + "." + idCampoCodigoPostal).hide();

    $("#" + idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $("#" + idForm + "#requeridos_provincia").val(""); //Para que NO sea obligatorio el campo provincia
  }
}

function configurarTelefono(idpais, codigoTelefonico, pattern, idForm = "frmCupon ", idCampoTelefono = "form_cupon_cupon_telefono") {

  $("#" + idForm + '#prefTelf').find('.prefijo-box').html('+' + codigoTelefonico.replace(/^0+/, ''));

  if (empty(pattern)) {
    $("#" + idForm + "#" + idCampoTelefono).removeAttr("pattern");
  } else {
    $("#" + idForm + "#" + idCampoTelefono).attr("pattern", pattern);
  }

  if (idpais == 90 || idpais == 'ES') {

    maxlengthTelefono = 9;
    minlengthTelefono = 9;

    $("#" + idForm + "#" + idCampoTelefono).attr("maxlength", maxlengthTelefono);
    $("#" + idForm + "#" + idCampoTelefono).attr("minlength", minlengthTelefono);
  } else {
    maxlengthTelefono = 25;
    const [min, max] = Array.from(pattern.matchAll(/\d+/g));

    $("#" + idForm + "#" + idCampoTelefono).attr("maxlength", max[0]);
    $("#" + idForm + "#" + idCampoTelefono).attr("minlength", min[0]);
  }

  $("#" + idForm + '#form_cupon_prefijo').val(codigoTelefonico);
}

function restringirCampoNumerico(idCampo, idForm = "frmCupon ") {
  $("#" + idForm + "#" + idCampo).on("input", function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, "")
        );
      }
    });
  });
}

/**
 *
 * @param {*} idForm
 * @param {*} iframe | on / off[default]
 */
function setForwardUrl(idForm, iframe) {
  var baseUrl = rutaweb + rutajs;
  var idEstudio = $("#" + idForm + " #form_cupon_idcurso").val();
  var telefono = $("#" + idForm + " #form_cupon_cupon_telefono").val();
  var nombre = $("#" + idForm + " #form_cupon_cupon_nombre").val();
  var transaction_id = $("#" + idForm + " #form_cupon_cupon_transaction_id").val();
  var adsid = $("#" + idForm + " #form_cupon_cupon_adsid").val();
  iframe = iframe === undefined ? "" : "&iframe=on";

  if (compruebaTelefonoCaracteres(idForm, "form_cupon_cupon_telefono"))
    return false;
  if (compruebaCampoVacio(idForm, "form_cupon_cupon_nombre"))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $("#" + idForm + "#btnInformacion").attr("disabled", true);
  $("#" + idForm + "#btnInformacion").html(htmlSpinner);

  if (typeof rutamainjs === "undefined") baseUrl = rutaweb + rutajs;
  else baseUrl = rutaweb + rutamainjs;

  $("#" + idForm + " #forward_url").val(
    baseUrl +
      "gracias?codCursoReal=" +
      idEstudio +
      "&telefono=" +
      telefono +
      "&nombre=" +
      nombre +
      "&transaction_id=" +
      transaction_id +
      "&adsid=" +
      adsid +
      iframe
  );
  enviarEventoFormulario(0, idForm);
  enviarEventoFormulario(3, idForm);
  return true;
}

function enviarEvento(){
  var valorTipo = 'oposicion';
  var valorCategoria = $('#form_cupon_categoria').val();
  var valorCurso = $('#form_cupon_nombre_curso').val();

  window.dataLayer = window.dataLayer|| [];
  window.dataLayer.push({
  event: 'form_submit',
  step: '1',
  template: v_template,
  menu_level_1: v_menu_level_1,
  menu_level_2: v_menu_level_2,
  menu_level_3: v_menu_level_3,
  menu_level_4: v_menu_level_4,
  menu_level_5: v_menu_level_5,
  form_id: datalayerFormID,
  form_specialization: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
  form_category: valorCategoria, // Aquí la categoría de la elección anterior. 
  form_course: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  form_type: valorTipoCupon,
  form_name: v_form_name,
  page_path: v_page_path,
  page_url: v_page_url
  });
}

function enviarEventoFormulario(tipoEvento = 0, idForm = "frmCupon"){
  var valorTipo = 'oposicion';

  valorTipoCupon = $('#' + idForm).find('#tipo_cupon').val();
  if (typeof valorTipoCupon === 'undefined')
    valorTipoCupon = 'PDP';

  var valorCategoria = v_form_category = $('#' + idForm).find('#form_cupon_categoria').val();
  if (typeof valorCategoria === 'undefined') {
    var valorCategoria = 'undefined';
    var v_form_category = 'undefined';
  }

  var valorCurso = $('#' + idForm).find('#form_cupon_nombre_curso').val();
  if (typeof valorCurso === 'undefined')
    var valorCurso = 'undefined';

  var valorPais = $('#' + idForm).find('#paisid option:selected').html();
  if (valorPais == '-- Pais --' || typeof valorPais === 'undefined')
    valorPais = 'undefined';
  
  var valorProvincia = $('#' + idForm).find('#provinciaid option:selected').html();
  if(valorProvincia == '-- Provincia --' || valorProvincia == '-- Estado --' || valorProvincia == '-- MARCA TU PROVINCIA --' || typeof valorProvincia === 'undefined')
    valorProvincia = 'undefined';

  var valorNacionalidad = $('#' + idForm).find('#nacionalidad option:selected').html();
  if (valorNacionalidad == '-- Nacionalidad --' || valorNacionalidad == '-- MARCA TU NACIONALIDAD --' || typeof valorNacionalidad === 'undefined')
    valorNacionalidad = 'undefined';

  var valorEdad = $('#' + idForm).find('#edad option:selected').html();
  if (valorEdad == '-- Edad --' || typeof valorEdad === 'undefined')
    valorEdad = 'undefined';

  var valorEstudios = $('#' + idForm).find('#estudiosid option:selected').html();
  if (valorEstudios == '-- Nivel de estudios --' || '-- Nivel Estudios --' || '-- MARCA TUS ESTUDIOS --' || typeof valorEstudios === 'undefined')
    valorEstudios = 'undefined';

  var valorCentro = $('#' + idForm).find('#form_cupon_centros').val();
  if (typeof valorCentro === 'undefined')
    valorCentro = 'undefined';

  var valorInstituto = $('#' + idForm).find('#form_cupon_instituto').val();
  if (typeof valorInstituto === 'undefined')
    valorInstituto = 'undefined';

  // Recogemos valor de Nombre, Email, Teléfono y CP y los hasheamos
  var valorNombre = $('#' + idForm).find('#form_cupon_cupon_nombre').val();
  var valorCP = $('#' + idForm).find('#form_cupon_cupon_codigopostal').val();
  var valorEmail = $('#' + idForm).find('#form_cupon_cupon_email').val();
  var valorTelefono = $('#' + idForm).find('#form_cupon_cupon_telefono').val();
  if(empty(valorEmail)) {
    valorEmail = 'undefined';
    valorHashEmail = 'undefined';
    valorHashStandardEmail = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashEmail = data.cadena;
      },
      error: function() {
        valorHashEmail = 'undefined';
      }
    });


    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardEmail = data.cadena;
      },
      error: function() {
        valorHashStandardEmail = 'undefined';
      }
    });
  }
  if(empty(valorTelefono)) {
    valorTelefono = 'undefined';
    valorHashTelefono = 'undefined';
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashTelefono = data.cadena;
      },
      error: function() {
        valorHashTelefono = 'undefined';
      }
    });
    
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardTelefono = data.cadena;
      },
      error: function() {
        valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHABase64&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.cadena;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
      valorHashStandardNombre = 'undefined';
    }
  }

  if(empty(valorCP)) {
    valorCP = 'undefined';
    valorHashCP = 'undefined';
    valorHashStandardCP = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorCP_2 = valorCP;

    if (valorCP_2.includes(" ")) {
      valorCP_2 = valorCP_2.replace(/\s+/g, ""); // Elimina todos los espacios
    }
    if (valorCP_2.includes("-")) {
      valorCP_2 = valorCP_2.replace(/-/g, ""); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashCP = data.cadena;
      },
      error: function() {
        valorHashCP = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardCP = data.cadena;
      },
      error: function() {
        valorHashStandardCP = 'undefined';
      }
    });
  }

  if(empty(valorPais)) {
    valorPais = 'undefined';
    valorHashPais = 'undefined';
    valorHashStandardPais = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorPais_2 = valorPais;

    if (valorPais_2.includes(' ')) {
      valorPais_2 = valorPais_2.replace(/\s+/g, ''); // Elimina todos los espacios
    }
    if (valorPais_2.includes('-')) {
      valorPais_2 = valorPais_2.replace(/-/g, ''); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorPais_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashPais = data.cadena;
      },
      error: function() {
        valorHashPais = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorPais_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardPais = data.cadena;
      },
      error: function() {
        valorHashStandardPais = 'undefined';
      }
    });
  }
  
  var valorTransaction = $('#' + idForm).find('#transactionIdWeb').val();
  if (typeof valorTransaction === 'undefined')
    valorTransaction = 'undefined';

  if (tipoEvento == 0){
    window.dataLayer = window.dataLayer|| [];
    window.dataLayer.push({
    event: 'form_submit',
    step: '2',
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    form_id: datalayerFormID,
    form_type: valorTipoCupon,
    form_specialization: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
    form_category: valorCategoria, // Aquí la categoría de la elección anterior. 
    form_course: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
    form_province: valorProvincia, // Queremos saber de qué provincia es.
    form_nationality: valorNacionalidad, // Queremos saber de qué nacionalidad es.
    form_age: valorEdad, // Queremos saber la edad escogida. 
    form_education: valorEstudios, // Queremos el nivel de estudios que ha indicado 
    form_centre: valorCentro,
    form_institute: valorInstituto,
    form_name: v_form_name,
    hashed_country: valorHashPais, // Queremos saber de qué país es.
    hashed_cp: valorHashCP, // Queremos saber el código postal.
    hashed_country_edu: valorHashStandardPais,
    hashed_cp_edu: valorHashStandardCP,
    page_path: v_page_path,
    page_url: v_page_url
    });
  }else if (tipoEvento == 1){ // view_form
    var aFields = [];

    $('#' + idForm).find('input, select, textarea').each(function() {
      if (this.name && this.type !== 'hidden' && $(this).is(':visible') && aFields.indexOf(this.name) === -1) {
        aFields.push(this.name);
      }
    });

    aFields = aFields.join(',');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_form",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_modality: v_modality,
      form_fields: aFields,
      page_path: v_page_path,
      page_url: v_page_url,
    });
    
  }else if (tipoEvento == 2){ // form_start
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_start",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      cta_copy: v_cta_copy,
      cta_section: v_cta_seccion,
      start_field: startField,
      page_path: v_page_path,
      page_url: v_page_url,
    });
  }else if (tipoEvento == 3){ // generate_lead
    var valorCursoId = $('#form_cupon_idcurso_real').val();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      edu_pid: valorCursoId,
      transaction_id: valorTransaction,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      form_age: valorEdad,
      form_education: valorEstudios,
      form_province: valorProvincia,
      form_centre: valorCentro,
      form_institute: valorInstituto,
      form_nationality: valorNacionalidad,
      hashed_mail: valorHashEmail,
      hashed_phone: valorHashTelefono,
      hashed_cp: valorHashCP,
      hashed_name: valorHashNombre,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_cp_edu: valorHashStandardCP,
      hashed_name_edu: valorHashStandardNombre,
      page_path: v_page_path,
      page_url: v_page_url,
    });
    
  }else if (tipoEvento == 4){ // error_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error_form",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      transaction_id: valorTransaction,
      form_id: datalayerFormID,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_course: valorCurso,
      form_modality: v_modality,
      form_age: valorEdad,
      form_education: valorEstudios,
      form_province: valorProvincia,
      form_centre: valorCentro,
      form_institute: valorInstituto,
      form_nationality: valorNacionalidad,
      hashed_mail: valorHashEmail,
      hashed_phone: valorHashTelefono,
      hashed_cp: valorHashCP,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_cp_edu: valorHashStandardCP,
      cta_copy: v_cta_copy,
      cta_section: v_cta_seccion,
      page_path: v_page_path,
      page_url: v_page_url,
      error_field: errorField,
      error_message: errorMessage,
    });
  }
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
      '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
      $(spinnerContenedor).appendTo(elementoContenedor);
      $('.spinner-contenedor').html(htmlSpinner);
  } else {
    $('.spinner-contenedor').remove();
  }
}

function cargaDatosCurso(idForm = "frmCupon ") {
  $('#' + idForm + '#form_cupon_categoria').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('categoria'));
  $('#' + idForm + '#form_cupon_nombre_curso').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('nombre-curso'));
  $('#' + idForm + '#form_cupon_idcurso_real').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('id-curso-real'));
  $('#' + idForm + '#form_cupon_instituto').val($('#' + idForm + '#form_cupon_idcurso option:selected').data('instituto'));
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $("#" + form_id + " #" + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $("#" + form_id + " #" + telefono).val("");
  inputTelefono.reportValidity();

  return true;
}

function compruebaCampoVacio(form_id, campo) {
  var nCampo = $("#" + form_id + " #" + campo).val();
  var inputCampo = document.getElementById(campo);

  if (nCampo.trim().length !== 0) return false;

  $("#" + form_id + " #" + campo).val("");
  inputCampo.reportValidity();

  return true;
}

function validarCMB(form_id) {
  var result = false;
  var nombre = $('#' + form_id + ' #input-nombre').val();
  var telefono = $('#' + form_id + ' #input-telefono').val();

  if(empty(nombre)) {
    $('#' + form_id + ' #error-nombre').show();

    return false;
  }

  if (compruebaTelefonoCaracteres(form_id, "input-telefono")) {
    $('#' + form_id + ' #error-telefono').show();

    return false;
  }

  $('#' + form_id + ' #error-nombre').hide();
  $('#' + form_id + ' #error-telefono').hide();
  
  $('#' + form_id + ' #btn-llamame-ahora-custom').addClass('hide-llamamos');

  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + "lib/ajax.php",
    data : 'fn=putLlamamos&wru='+cdn_rutaweb+cdn_rutaactual+'&iw='+cdn_idweb+'&rcdn='+cdn_rutacdn+'&t='+telefono+'&n='+nombre,
    success: function(data) {
      if(data == 1) {
        errorField = 'general';
        errorMessage = 'Algo no ha salido bien';

        enviarEventoFormulario(4, form_id);

        result = false;
      } else {
        eventoCustomCMB(nombre, telefono);

        result = true;
      }
    },
    error: function() {
      errorField = 'general';
      errorMessage = 'Algo no ha salido bien';

      enviarEventoFormulario(4, form_id);

      result = false;
    }
  });

  if(!result)
    alert('Envio incorrecto. Se ha producido un error, por favor, vuelva a intentarlo pasados unos minutos.')

  return result;
}

function eventoCustomCMB(valorNombre, phone) {
  if(empty(phone)) {
    phone = 'undefined';
    valorHashTelefono = 'undefined';
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+phone,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashTelefono = data.cadena;
      },
      error: function() {
        valorHashTelefono = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+phone,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardTelefono = data.cadena;
      },
      error: function() {
        valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHABase64&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.cadena;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });
  
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
      valorHashStandardNombre = 'undefined';
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_submit",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_id: datalayerFormID,
    form_modality: v_modality,
    form_type: 'Modal',
    form_name: v_form_name,
    hashed_name: valorHashNombre,
    hashed_phone: valorHashTelefono,
    hashed_name_edu: valorHashStandardNombre,
    hashed_phone_edu: valorHashStandardTelefono,
    cta_copy: v_cta_copy,
    cta_section: v_cta_seccion,
    page_path: v_page_path,
    page_url: v_page_url
  });
}

function enviarEventoViewForm(idForm = "frmCupon"){
  enviarEventoFormulario(1, idForm);
}

function contieneClasesEnArray(clases){
  var contiene = false;

  if(!empty(clases)) {
    var aClases = clases.split(' ');

    $.each(aClases, function (key, value) {
      if(jQuery.inArray(value, aClasesMakingScience) != -1)
        contiene = true;
    });
  }
  
  return contiene;
}

$(document).on('click', '.cta_menu_header',  function(e){
  if(!empty($(this).parent().parent().parent().parent().parent().parent().parent().parent().prev('.cta_menu_header').text().trim())) {
    var v_menu_category = $(this).parent().parent().parent().parent().parent().parent().parent().parent().prev('.cta_menu_header').text().trim().toUpperCase();
    var v_menu_subcategory = $(this).text().trim().toUpperCase();

    v_cta_copy = v_menu_subcategory;
  } else {
    var v_menu_category = $(this).text().trim().toUpperCase();
    var v_menu_subcategory = 'undefined';

    v_cta_copy = v_menu_category;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_header",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    nav_category: v_menu_category,
    nav_subcategory: v_menu_subcategory,
    cta_name: "menu_header",
    cta_copy: v_cta_copy,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.cta_menu_footer',  function(e){
  if(!empty($(this).parent().parent().parent().prev('.cta_menu_footer').attr('data-texto'))) {
    var v_menu_category = $(this).parent().parent().parent().prev('.cta_menu_footer').attr('data-texto').toUpperCase();
  } else if(!empty($(this).parent().parent().prev('.cta_menu_footer').text().trim())) {
    var v_menu_category = $(this).parent().parent().prev('.cta_menu_footer').text().trim().toUpperCase();
  } else {
    var v_menu_category = $(this).text().trim().toUpperCase();
  }

  v_cta_copy = v_menu_category;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_footer",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    nav_category: v_menu_category,
    cta_name: "menu_footer",
    cta_copy: v_cta_copy,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', 'a, button',  function(e){
  if(!contieneClasesEnArray($(this).attr('class'))) {

    if(!empty($(this).text().trim()))
      v_cta_copy = $(this).text().trim();
    else if(!empty($(this).attr('title')))
      v_cta_copy = $(this).attr('title');
    else if(!empty($(this).attr('alt')))
      v_cta_copy = $(this).attr('alt');
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_content",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      cta_name: "GENERIC", 
      cta_copy: v_cta_copy.toUpperCase(), 
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
});

$(document).on('click', '.carousel',  function(e){
  var v_carousel_name = $(this).parent().parent().parent().attr('data-name');
  
  if(v_carousel_name != undefined) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "carousel",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      carousel_name: v_carousel_name.toUpperCase(),
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
});

$(document).on('click', '.cta_cmb',  function(e){
  v_cta_copy = $(this).text().trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_cmb",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    cta_name: 'CMB',
    cta_copy: v_cta_copy.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.click_cmb',  function(e){
  datalayerFormID = 'form_cmb';

  v_cta_copy = $(this).text().trim();
  v_cta_seccion = $(this).data('position').trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "click_cmb",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_id: datalayerFormID,
    cta_cmb : v_cta_copy.toUpperCase(),
    cta_seccion: v_cta_seccion,
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.cta_mapa',  function(e){
  var v_map_icon = $(this).attr('data-icon');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_mapa",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    map_icon: v_map_icon.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

$(document).on('click', '.share',  function(e){
  var v_share_position = $(this).attr('data-position');
  var v_platform = $(this).attr('data-platform');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "share",
    template: v_template,
    menu_level_1: v_menu_level_1,
    menu_level_2: v_menu_level_2,
    menu_level_3: v_menu_level_3,
    menu_level_4: v_menu_level_4,
    menu_level_5: v_menu_level_5,
    customer_id: v_client_id,
    form_specialization: 'oposicion',
    form_modality: v_modality,
    share_position: v_share_position.toUpperCase(),
    platform: v_platform.toUpperCase(),
    page_path: v_page_path,
    page_url: v_page_url
  });
});

function enviarEventoScrollPage(v_scroll_percentage) {
  var porcentajeActual = $('footer').attr('data-porcentaje');
  var sendEvent = false;

  if(v_scroll_percentage >= 90 && porcentajeActual < 90) {
    sendEvent = true;
    v_scroll_percentage = 90;
  } else if(v_scroll_percentage >= 75 && porcentajeActual < 75) {
    sendEvent = true;
    v_scroll_percentage = 75;
  } else if(v_scroll_percentage >= 50 && porcentajeActual < 50) {
    sendEvent = true;
    v_scroll_percentage = 50;
  } else if(v_scroll_percentage >= 25 && porcentajeActual < 25) {
    sendEvent = true;
    v_scroll_percentage = 25;
  }

  if(sendEvent) {
    $('footer').attr('data-porcentaje', v_scroll_percentage);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "scroll_custom",
      template: v_template,
      menu_level_1: v_menu_level_1,
      menu_level_2: v_menu_level_2,
      menu_level_3: v_menu_level_3,
      menu_level_4: v_menu_level_4,
      menu_level_5: v_menu_level_5,
      customer_id: v_client_id,
      form_specialization: 'oposicion',
      form_modality: v_modality,
      scroll_percentage: v_scroll_percentage,
      page_path: v_page_path,
      page_url: v_page_url
    });
  }
}

function scrollPage() {
  scroll = $(window).scrollTop();
  heightFooter = $('footer').outerHeight();
  totalPage = $('footer').offset().top;

  enviarEventoScrollPage((scroll * 100) / (totalPage - heightFooter));
}

$(window).scroll(function (event) {
  scrollPage();
});

$(window).resize(function (event) {
  scrollPage();
});